import script from "./StandardLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./StandardLayout.vue?vue&type=script&setup=true&lang=ts"

import "./StandardLayout.vue?vue&type=style&index=0&id=2189ddff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2189ddff"]])

export default __exports__